document.addEventListener('DOMContentLoaded', ()=>{

    document.querySelectorAll('.bandListicle__testimonial__interior.swiper').forEach((el)=>{
        new Swiper(el, {
            spaceBetween: 32,
            slidesPerView: 'auto',loop:true,centeredSlides: true,slidesOffsetAfter: 0,
            navigation: {nextEl: ".bandListicle__testimonial__interior .swiper-button-next", prevEl: ".bandListicle__testimonial__interior .swiper-button-prev"},
            pagination: { el: ".bandListicle__testimonial__interior .swiper-pagination"}
        });    
    })

    function isInViewportStickyElement(elem) { 
        var bounding = elem.getBoundingClientRect();
        var myElementHeight = elem.offsetHeight;
        var myElementWidth = elem.offsetWidth;
        return (bounding.top >= -myElementHeight && bounding.left >= -myElementWidth && bounding.right <= (window.innerWidth || document.documentElement.clientWidth) + myElementWidth && bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) + myElementHeight) ; 
    }; 
    
    var recommendationElementTest = document.querySelectorAll('.mapwithouttest');
    window.addEventListener('scroll', ()=>{
        recommendationElementTest.forEach( (evt)=>{
        if ( isInViewportStickyElement(evt) ) {
            document.querySelectorAll(".withoutabteststk").forEach((target)=>{
            target.classList.add('hidden');
            });
        }else{
            document.querySelectorAll(".withoutabteststk").forEach((target)=>{
            target.classList.remove('hidden');
            });
        }
        })
    })
    
    const videoWrapper = document.querySelector('.bandListicle__mainbanner, .WillNotShowOnBodyPodPDMN');
    const scrollingBar = document.querySelector('.ListScrollingBarWp');
    const announcementBar = document.querySelector('#shopify-section-announcement-bar');

    function handleScroll() {
        const scrollPosition = window.scrollY;
        if (videoWrapper) {
        const showBuyBarPosition = videoWrapper.offsetTop;
        if (scrollPosition > showBuyBarPosition) {
            scrollingBar.classList.add('active');
            document.body.classList.add('HiddenHeaderBar');
        } else {
            scrollingBar.classList.remove('active');
            document.body.classList.remove('HiddenHeaderBar');
        }
        }
        const announcementBarHeight = announcementBar.offsetHeight;
        scrollingBar.style.top = `${announcementBarHeight}px`;
    }
    window.addEventListener('scroll', handleScroll);    

    var quantity = document.querySelector('.quantity-control-button.add'); if(quantity){ quantity.addEventListener('click', function(e){ e.preventDefault(); var inputElement  = this.closest('.number-input-control').querySelector('.input-text'); var inputValue = parseInt(inputElement.value) || 0; inputElement.value = inputValue + 1; }) }
    var minusQuantity = document.querySelector('.quantity-control-button.subtract'); if(minusQuantity){ minusQuantity.addEventListener('click', function(e){ e.preventDefault(); var inputElement  = this.closest('.number-input-control').querySelector('.input-text'); var inputValue = parseInt(inputElement.value) || 0; if (inputValue > 1) { inputElement.value = inputValue - 1; }})}    
    var popupContentWrapper = document.querySelectorAll(".hsa-fsa-popup-content-wrapper"); if(popupContentWrapper.length){ popupContentWrapper.forEach(function(popup){ popup.addEventListener("click", function() { document.body.classList.add("hsa-popup-open"); document.querySelector(".hsapopupContainer").classList.add("active-open"); }); }) }
    var closeButtn = document.querySelector('.hsapopupContainer .hsaCrsBtn'); if(closeButtn){ closeButtn.addEventListener('click', function() { document.body.classList.remove('hsa-popup-open'); document.querySelector('.hsapopupContainer').classList.remove('active-open'); }); }
    document.addEventListener('click', function(event) {
        var targetElement = event.target.closest('.Wphyopyiomshy');
        if (targetElement) { 
            event.preventDefault();
            targetElement.classList.add('active');
            var siblings = targetElement.parentNode.querySelectorAll('.Wphyopyiomshy');
            siblings.forEach(function(sibling) {
            if (sibling !== targetElement) {
                sibling.classList.remove('active'); 
            } 
            });
        } 
    });   
    
    var oncliickpopup= document.querySelectorAll('.Wphyopyiomshy');
    if(oncliickpopup.length > 0){ 
        oncliickpopup.forEach((el)=>{
            el.addEventListener('click', function (evt) {
                evt.preventDefault();
                if( evt.target.closest('.Wphyopyiomshy').classList.contains('OnlyAvailThat')){
                    document.querySelector('.OneClick_Popup').classList.remove('show-checked');
                }else{
                    document.querySelector('.OneClick_Popup').classList.add('show-checked');
                }
             })
        })
    }

    document.querySelector('.OneClick_Popup').addEventListener('click', function(evt){
    evt.preventDefault();
    if (!this.classList.contains('show-checked')) {
        let thisElm = this;
        thisElm.classList.add('clickedMe');
        var mainID = this.getAttribute('main-productid'); var mnpQy = document.querySelector('[title="Qty"]').value; var formData = new FormData(); 
        formData.append('quantity', mnpQy); formData.append('id', mainID); fetch('/cart/add.js', { method: 'POST', body: formData }) 
        .then(response => { if (!response.ok) { throw new Error('Network response was not ok'); } return response.json(); }) 
        .then(data => {
        thisElm.classList.remove('clickedMe');
        window.location.href = '/checkout'; 
        }) 
    }else if(this.classList.contains('WarrantyDisabledPopup')){
        let thisElm = this;
        thisElm.classList.add('clickedMe');
        var mainID = this.getAttribute('data-without-popup'); var mnpQy = document.querySelector('[title="Qty"]').value; var formData = new FormData(); 
        formData.append('quantity', mnpQy); formData.append('id', mainID); fetch('/cart/add.js', { method: 'POST', body: formData }) 
        .then(response => { if (!response.ok) { throw new Error('Network response was not ok'); } return response.json(); }) 
        .then(data => {
        thisElm.classList.remove('clickedMe');
        window.location.href = '/checkout'; 
        })      
    }else{
        document.querySelector('.Product_Popup').classList.add('popup-open'); document.body.classList.add('popup-show');
    }
    })

    document.querySelectorAll('.accordianjshandle').forEach((elm)=>{
        elm.addEventListener('click', (target)=>{
            target.preventDefault();
            target.target.closest('.custom-faqs-Items').classList.toggle('active');
        });
    });  

    let ScrollTargetPDP = document.querySelectorAll(".ScrollerPdpAtc, .Dsrgyu, .Humeband-block-button, [js-scroll-to-destination]");
    ScrollTargetPDP.forEach((evt)=>{
        evt.addEventListener('click', (target)=>{
            target.preventDefault();
            if(window.innerWidth > 769){
            var targetElement = document.querySelector('.MainProductRightPortionWp');
            window.scrollTo({
                top: targetElement.offsetTop - document.querySelector('#shopify-section-announcement-bar').clientHeight,
                behavior: 'smooth'
            });
            }else{
            var targetElement = document.querySelector('.WarrantyProtectionWp');
            window.scrollTo({
                top: targetElement.offsetTop - 120,
                behavior: 'smooth'
            });
            }  
        })
    });

    document.querySelectorAll('.wpunijtysh').forEach((elm)=>{
        elm.addEventListener('click', (target)=>{
            target.preventDefault();
            if( target.currentTarget.classList.contains('TargetToDivElement') ){
            var targetElement = document.querySelector('.WidgetreviewsLoader');
            if ( window.screen.width > 769) {
                window.scrollTo({
                top: targetElement.offsetTop - 158,
                behavior: 'smooth'
                });    
            }else{
                window.scrollTo({
                top: targetElement.offsetTop,
                behavior: 'smooth'
                });           
            }        
            }else{
            target.target.closest('.Tabinityiniopsmkm').classList.toggle('active');
            }
        });
    });     
    
    document.querySelectorAll('.Tilemnexh').forEach((elm)=>{
        elm.addEventListener('click', (target)=>{
        target.preventDefault();
        target.target.closest('.CollpsmnTabex').classList.toggle('active');
        });
    });

})